import React, { useEffect, useState } from "react";

//  DEFENCE APPLICATIONS – FINAL SECTION (DARK THEME, BOOTSTRAP ICONS, NO CONFLICT)
const DefenceApplications = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //  DEFENCE APPLICATIONS – STYLE NAMESPACE (SAFE & ISOLATED)
  const defenceStyles = {
    defenceSection: {
      width: "100%",
      padding: isMobile ? "80px 24px" : "120px 60px",
      background: "linear-gradient(180deg, #0b0b0b 0%, #111111 100%)",
    },

    defenceHeader: {
      textAlign: "center",
      marginBottom: isMobile ? "50px" : "80px",
    },

    defenceHeading: {
      fontSize: isMobile ? "28px" : "40px",
      fontWeight: 700,
      color: "#ffffff",
      marginBottom: "12px",
    },

    defenceSubheading: {
      fontSize: isMobile ? "14px" : "16px",
      color: "#9ca3af",
    },

    defenceGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(4, 1fr)",
      gap: isMobile ? "24px" : "40px",
      maxWidth: "1400px",
      margin: "0 auto",
    },

    defenceCard: {
      backgroundColor: "#1a1a1a",
      borderRadius: "18px",
      padding: isMobile ? "36px 20px" : "44px 24px",
      textAlign: "center",
      boxShadow: "0 0 0 1px rgba(255,255,255,0.04)",
      transition: "all 0.3s ease",
    },

    defenceIconCircle: {
      width: "64px",
      height: "64px",
      borderRadius: "18px",
      backgroundColor: "#ff7a00",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 auto 20px",
      color: "#ffffff",
      fontSize: "28px",
    },

    defenceCardTitle: {
      fontSize: "18px",
      fontWeight: 600,
      color: "#ffffff",
      marginTop: "6px",
    },
  };

  return (
    <section style={defenceStyles.defenceSection}>
      {/* HEADER */}
      <div style={defenceStyles.defenceHeader}>
        <h2 style={defenceStyles.defenceHeading}>Critical Defence Applications</h2>
        <p style={defenceStyles.defenceSubheading}>
          Deployed across weapon systems and combat platforms
        </p>
      </div>

      {/* APPLICATION GRID */}
      <div style={defenceStyles.defenceGrid}>

        {/* CARD 1 */}
        <div style={defenceStyles.defenceCard}>
          <div style={defenceStyles.defenceIconCircle}>
            <i className="bi bi-bullseye"></i>
          </div>
          <div style={defenceStyles.defenceCardTitle}>Weapon Systems</div>
        </div>

        {/* CARD 2 */}
        <div style={defenceStyles.defenceCard}>
          <div style={defenceStyles.defenceIconCircle}>
            <i className="bi bi-crosshair"></i>
          </div>
          <div style={defenceStyles.defenceCardTitle}>Fire-Control Systems</div>
        </div>

        {/* CARD 3 */}
        <div style={defenceStyles.defenceCard}>
          <div style={defenceStyles.defenceIconCircle}>
            <i className="bi bi-shield-check"></i>
          </div>
          <div style={defenceStyles.defenceCardTitle}>CMS Integration</div>
        </div>

        {/* CARD 4 */}
        <div style={defenceStyles.defenceCard}>
          <div style={defenceStyles.defenceIconCircle}>
            <i className="bi bi-broadcast"></i>
          </div>
          <div style={defenceStyles.defenceCardTitle}>Defence Test Benches</div>
        </div>

      </div>
    </section>
  );
};

export default DefenceApplications;
